import React from 'react';
import { Locales } from "../../helper/Locales.js";
import { Input } from "../input/Input.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const InputUnit = ({
  locale = 'de',
  format = {},
  suffix = 'currency',
  onChange,
  ...props
}) => {
  const formatConfig = Locales[locale];
  const formatProp = {
    suffix: formatConfig.suffix[suffix],
    thousandSeparator: formatConfig.thousandSeparator,
    decimalSeparator: formatConfig.decimalSeparator,
    decimalScale: 2,
    isNumericString: true,
    ...format,
    onValueChange: (values, sourceInfo) => {
      format.onValueChange?.(values, sourceInfo);
      onChange?.(values, sourceInfo);
    }
  };
  return /*#__PURE__*/_jsx(Input, {
    format: formatProp,
    ...props
  });
};